import type { DEVICE_PERMISSION } from 'YM/declare';

import type { EVoxRoles } from 'providers/declare';

/** Данные, отправляемые при ошибках */
export interface ErrorMetricsParams {
    Meeting: {
        Meeting_params: {
            meeting_id: string | undefined;
            meeting_role: EVoxRoles;
            setting_permission_camera: DEVICE_PERMISSION;
            setting_permission_mic: DEVICE_PERMISSION;
        };
        System_error: {
            errorData: unknown;
            errorName: string;
        };
        User_params: {
            [tokenName: string]: string;
        };
    };
}

export function formatErrorParams(params: ErrorMetricsParams): ErrorMetricsParams {
    const { errorData } = params.Meeting.System_error;

    return {
        Meeting: {
            ...params.Meeting,
            System_error: {
                ...params.Meeting.System_error,
                errorData: JSON.stringify(errorData, Object.getOwnPropertyNames(errorData)),
            },
        },
    };
}
